module.exports = __webpack_public_path__ + "img/exercise.0a4b293d.png";